import digitalPrinting from "./templates/digital-printing";

export default [
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `<p>Открытка размером 21х10 см. Печать производится с одной стороны.</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${digitalPrinting}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
